import { useCommunityContext } from 'providers';
import { ascend } from 'ramda';

import { SchoolConfigurationExternalLink, SchoolConfigurationLayout } from 'shared/graphql';

/**
 * A custom hook that provides access to the current school configuration and related actions.
 * @deprecated Use `useCommunityContext` instead.
 */
export function useSchoolConfiguration() {
  const { selectedCommunity, loading, selectCommunity } = useCommunityContext();

  return {
    /** @deprecated Use `useCommunityContext` instead. */
    data: selectedCommunity,
    /** @deprecated Use `data` instead. */
    configuration: selectedCommunity,

    /** @deprecated Use `selectCommunity` instead. */
    selectSchool: selectCommunity,
    /**
     * Allow to switch the selected school.
     * @param id The `id` of the school to select.
     * @deprecated Use `useCommunityContext` instead.
     */
    selectCommunity,
    /** @deprecated Use `useCommunityContext` instead. */
    loading,
  };
}

export const sortMobileLabels = (
  items: SchoolConfigurationLayout[],
): SchoolConfigurationLayout[] => {
  const pages = [...items];

  return pages
    .filter(page => typeof page?.navbarOrderNumber === 'number')
    .sort(ascend(page => page?.navbarOrderNumber as number));
};

export const sortExternalLinks = (
  items: SchoolConfigurationExternalLink[],
): SchoolConfigurationExternalLink[] => {
  const copiedItems = [...items];
  copiedItems.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  return copiedItems;
};
